<template>
    <!-- 注释等信息 -->
    <div class="poem-detail-info">
        <el-tabs type="border-card">
            <!-- 注解 -->
            <el-tab-pane>
                <span slot="label"><i class="iconfont iconchuangzuo"></i> 注解</span>
                <div class="content" v-html="poem.notes.replace('style','')"></div>
            </el-tab-pane>
            <!-- 翻译 -->
            <el-tab-pane>
                <span slot="label"><i class="iconfont icongushu"></i> 翻译</span>
                <div class="content" v-html="poem.translation.replace('style','')"></div>
            </el-tab-pane>
            <!-- 创作背景 -->
            <el-tab-pane>
                <span slot="label"><i class="iconfont iconzhuzi"></i> 创作背景</span>
                <div class="content" v-html="poem.background.replace('style','')"></div>
            </el-tab-pane>
            <!-- 赏析 -->
            <el-tab-pane>
                <span slot="label"><i class="iconfont iconcha"></i> 赏析</span>
                <div class="content" v-html="poem.appreciation.replace('style','')"></div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    export default {
        name: "Info",
        props:["poem"]
    }
</script>

<style scoped lang="less">
    .poem-detail-info{
        width: 60%;
        margin: 25px auto;
        /* 正文内容 */
        .content{
            line-height: 25px;
            font-size: 22px;
            font-family: 楷体,宋体 !important;
        }
    }
</style>